import SkeletonCardSink from './SkeletonCardAppliance';
import SkeletonCardColor from './SkeletonCardColor';

type SkeletonType = 'color' | 'appliance';

type SkeletonCardProps = {
  type: SkeletonType;
};

const skeletonType: Record<SkeletonType, React.ComponentType<unknown>> = {
  color: SkeletonCardColor,
  appliance: SkeletonCardSink,
};

export const SkeletonCard = ({ type }: SkeletonCardProps) => {
  const Skeleton = skeletonType[type];

  return <Skeleton />;
};

export default SkeletonCard;
